import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setPersonalDetails } from '../../../Redux/userSlice'; // Import action
import MainNavbar from '../MainNavbar';
import './Create.css';

const Create = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch(); // Initialize dispatch
  const location = useLocation();
  const mode = location?.state?.mode || 'create'; // default to 'create'
  const [personalDetails, setPersonalDetailsState] = useState({
    userId: '',
    fatherName: '',
    fatherOccupation: '',
    motherName: '',
    motherOccupation: '',
    noOfSiblings: '',
    noOfBrothers: '',
    noOfSisters: '',
    noOfMarried: '',
    noOfUnmarried: '',
    familyClass: '',
    familyOrientation: '',
    userIncome: '',
    occupation: '',
    height: '',
    weight: '',
    complexion: '',
    disability: '',
    religion: '',
    caste: '',
    subCaste: '',
    location: {
      state: '',
      district: '',
    },
    hobbies: '',
    interest: '',
    drinkingHabits: '',
    smokingHabits: '',
    horoscope: '',
  });

  useEffect(() => {
    document.body.classList.add('body-background'); // Add background class to body

    return () => {
      document.body.classList.remove('body-background'); // Remove background class from body on unmount
    };
  }, []);
  const [step, setStep] = useState(1);

  const handleNext = () => {
    if (step === 1) setStep(2);
  };
  const handleBack = () => {
    if (step === 2) setStep(1);
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'noOfSiblings' && value === '0') {
      setPersonalDetailsState({
        ...personalDetails,
        [name]: value,
        noOfBrothers: 0,
        noOfSisters: 0,
        noOfMarried: 0,
        noOfUnmarried: 0,
      });
    } else {
      setPersonalDetailsState({
        ...personalDetails,
        [name]: value,
      });
    }
  };

  const handleLocationChange = (e) => {
    const { name, value } = e.target;
    setPersonalDetailsState({
      ...personalDetails,
      location: {
        ...personalDetails.location,
        [name]: value,
      },
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const apiUrl =
        mode === 'edit'
          ? 'https://back.varankal.com/user/update-details'
          : 'https://back.varankal.com/user/personal-details';

      await axios.post(apiUrl, { personalDetails }, { withCredentials: true });

      dispatch(setPersonalDetails(personalDetails));

      alert(
        mode === 'edit'
          ? 'Profile Updated successfully!'
          : 'Profile Created successfully!'
      );

      navigate('/preference', { state: { personalDetails } });
    } catch (error) {
      console.error(
        `Error ${mode === 'edit' ? 'updating' : 'creating'} profile:`,
        error
      );
    }
  };




  return (
    <>
      <MainNavbar />
      <div className='Create00'>
        <div className="register-left-container">

          <div className="register-left-content">
            <img src="/Images/icon tm.png" alt="Success Story" className="story-img" />
            <h1 className="register-left-title">Welcome to Varankal</h1>
            <p className="register-left-description">
              Find your perfect life partner with us. Create your profile, connect with like-minded individuals, and start your journey towards a happy and fulfilling relationship.
            </p>

            {/* ✅ Success Story */}
            <div className="register-left-story">

              <p>“I found my perfect co-founder through this platform. The connections are truly valuable!” – <strong>John Doe</strong></p>
            </div>

            {/* ✅ Call to Action */}
            <button
              className="register-left-btn"
              onClick={() => {
                window.scrollTo({ top: 0, behavior: 'smooth' }); // 👈 Scroll to top
                navigate('/aboutus');                       // 👈 Navigate to target page
              }}
            >
              Learn More →
            </button>

          </div>
        </div>


        <form onSubmit={handleSubmit}>
          <div className="form-container">
            <h1>Let's Create Your Profile</h1>
            {step === 1 && (
              <div className="form-column">
                <div className="form-row-dual">
                  <div className="form-group545">
                    <label htmlFor="formFatherName">Father's Name</label>
                    <input type="text" id="formFatherName" name="fatherName" value={personalDetails.fatherName} onChange={handleChange} required />
                  </div>
                  <div className="form-group545">
                    <label htmlFor="formFatherOccupation">Father's Occupation</label>
                    <input type="text" id="formFatherOccupation" name="fatherOccupation" value={personalDetails.fatherOccupation} onChange={handleChange} required />
                  </div>
                </div>
                <div className="form-row-dual">
                  <div className="form-group545">
                    <label htmlFor="formMotherName">Mother's Name</label>
                    <input type="text" id="formMotherName" name="motherName" value={personalDetails.motherName} onChange={handleChange} required />
                  </div>
                  <div className="form-group545">
                    <label htmlFor="formMotherOccupation">Mother's Occupation</label>
                    <input type="text" id="formMotherOccupation" name="motherOccupation" value={personalDetails.motherOccupation} onChange={handleChange} required />
                  </div>
                </div>
                <div className="form-row-dual">
                  <div className="form-group545">
                    <label htmlFor="formNoOfSiblings">Number of Siblings</label>
                    <input type="number" id="formNoOfSiblings" name="noOfSiblings" value={personalDetails.noOfSiblings} onChange={handleChange} required />
                  </div>
                  {personalDetails.noOfSiblings > 0 && (
                    <>
                      <div className="form-group545">
                        <label htmlFor="formNoOfBrothers">Number of Brothers</label>
                        <input type="number" id="formNoOfBrothers" name="noOfBrothers" value={personalDetails.noOfBrothers} onChange={handleChange} required />
                      </div>
                      <div className="form-group545">
                        <label htmlFor="formNoOfSisters">Number of Sisters</label>
                        <input type="number" id="formNoOfSisters" name="noOfSisters" value={personalDetails.noOfSisters} onChange={handleChange} required />
                      </div>
                      <div className="form-group545">
                        <label htmlFor="formNoOfMarried">Number of Married</label>
                        <input type="number" id="formNoOfMarried" name="noOfMarried" value={personalDetails.noOfMarried} onChange={handleChange} required />
                      </div>
                      <div className="form-group545">
                        <label htmlFor="formNoOfUnmarried">Number of Unmarried</label>
                        <input type="number" id="formNoOfUnmarried" name="noOfUnmarried" value={personalDetails.noOfUnmarried} onChange={handleChange} required />
                      </div>
                    </>
                  )}
                  <div className="form-group545">
                    <label htmlFor="formFamilyClass">Family Class</label>
                    <select id="formFamilyClass" name="familyClass" value={personalDetails.familyClass} onChange={handleChange} required>
                      <option value="">Select</option>
                      <option value="Upper Class">Upper Class</option>
                      <option value="Middle Class">Middle Class</option>
                      <option value="Lower Class">Lower Class</option>
                    </select>
                  </div>
                </div>
                <div className="form-row-dual">
                  <div className="form-group545">
                    <label htmlFor="formFamilyOrientation">Family Orientation</label>
                    <select id="formFamilyOrientation" name="familyOrientation" value={personalDetails.familyOrientation} onChange={handleChange} required>
                      <option value="">Select</option>
                      <option value="Traditional">Traditional</option>
                      <option value="Moderate">Moderate</option>
                      <option value="Liberal">Liberal</option>
                    </select>
                  </div>
                  <div className="form-group545">
                    <label htmlFor="formReligion">Religion</label>
                    <select
                      id="formReligion"
                      name="religion"
                      value={personalDetails.religion}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select</option>
                      <option value="Hindu">Hindu</option>
                      <option value="Muslim">Muslim</option>
                      <option value="Christian">Christian</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  {personalDetails.religion === 'Other' && (
                    <div className="form-group545">
                      <label htmlFor="customReligion">Please specify your religion</label>
                      <input
                        type="text"
                        id="customReligion"
                        name="customReligion"
                        value={personalDetails.customReligion || ''}
                        onChange={handleChange}
                        placeholder="Enter your religion"
                        required
                      />
                    </div>
                  )}
                </div>
                <div className="form-row-dual">
                  <div className="form-group545">
                    <label htmlFor="formCaste">Caste</label>
                    <input type="text" id="formCaste" name="caste" value={personalDetails.caste} onChange={handleChange} required />
                  </div>
                  <div className="form-group545">
                    <label htmlFor="formSubCaste">Sub-Caste</label>
                    <input type="text" id="formSubCaste" name="subCaste" value={personalDetails.subCaste} onChange={handleChange} required />
                  </div>
                </div>
                <div className="form-row-dual">
                  <div className="form-group545">
                    <label htmlFor="formHoroscope">Horoscope</label>
                    <input type="text" id="formHoroscope" name="horoscope" value={personalDetails.horoscope} onChange={handleChange} required />
                  </div>

                  <button type="button" className="submit-button0po" onClick={handleNext}>Next</button>
                </div>
              </div>

            )}

            {step === 2 && (
              <div className="form-column">

                <div className="form-row-dual">
                  <div className="form-group545">
                    <label htmlFor="formUserIncome">User Income</label>
                    <select
                      id="formUserIncome"
                      name="userIncome"
                      value={personalDetails.userIncome}
                      onChange={handleChange}
                      required
                    >
                      <option value="" disabled>Select Income</option>
                      <option value="Below ₹1 Lakh">Below ₹1 Lakh</option>
                      <option value="₹1 - ₹2 Lakhs">₹1 - ₹2 Lakhs</option>
                      <option value="₹2 - ₹4 Lakhs">₹2 - ₹4 Lakhs</option>
                      <option value="₹4 - ₹6 Lakhs">₹4 - ₹6 Lakhs</option>
                      <option value="₹6 - ₹10 Lakhs">₹6 - ₹10 Lakhs</option>
                      <option value="₹10 - ₹15 Lakhs">₹10 - ₹15 Lakhs</option>
                      <option value="₹15 - ₹20 Lakhs">₹15 - ₹20 Lakhs</option>
                      <option value="Above ₹20 Lakhs">Above ₹20 Lakhs</option>
                      {/* Add more income ranges as needed */}
                    </select>
                  </div>

                  {/* Occupation Dropdown */}
                  <div className="form-group545">
                    <label htmlFor="formOccupation">Occupation</label>
                    <select
                      id="formOccupation"
                      name="occupation"
                      value={personalDetails.occupation}
                      onChange={handleChange}
                      required
                    >
                      <option value="" disabled>Select Occupation</option>
                      <option value="Government Employee">Government Employee</option>
                      <option value="Private Employee">Private Employee</option>
                      <option value="Business Owner">Business Owner</option>
                      <option value="Self-Employed">Self-Employed</option>
                      <option value="Doctor">Doctor</option>
                      <option value="Engineer">Engineer</option>
                      <option value="Teacher/Professor">Teacher/Professor</option>
                      <option value="Lawyer">Lawyer</option>
                      <option value="Not Working">Not Working</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  {personalDetails.occupation === 'Other' && (
                    <div className="form-group545 full-width">
                      <label htmlFor="customOccupation">Please specify your occupation</label>
                      <input
                        type="text"
                        id="customOccupation"
                        name="customOccupation"
                        value={personalDetails.customOccupation || ''}
                        onChange={handleChange}
                        placeholder="Enter your occupation"
                        required
                      />
                    </div>

                  )}
                </div>


                <div className="form-row-dual">
                  <div className="form-group545">
                    <label htmlFor="formComplexion">Complexion</label>
                    <select id="formComplexion" name="complexion" value={personalDetails.complexion} onChange={handleChange} required>
                      <option value="">Select</option>
                      <option value="Fair">Fair</option>
                      <option value="Wheatish">Wheatish</option>
                      <option value="Dark">Dark</option>
                    </select>
                  </div>
                  <div className="form-group545">
                    <label htmlFor="formDisability">Disability</label>
                    <select id="formDisability" name="disability" value={personalDetails.disability} onChange={handleChange}>
                      <option value="">Select</option>
                      <option value="None">No</option>
                      <option value="yes">Yes</option>
                    </select>
                  </div>
                </div>
                <div className="form-row-dual">
                  <div className="form-group545">
                    <label htmlFor="formWeight">Weight (kg)</label>
                    <input type="number" id="formWeight" name="weight" value={personalDetails.weight} onChange={handleChange} required />
                  </div>
                  <div className="form-group545">
                    <label htmlFor="formHeight">Height (cm)</label>
                    <input type="number" id="formHeight" name="height" value={personalDetails.height} onChange={handleChange} required />
                  </div>
                </div>
                <div className="form-row-dual">
                  <div className="form-group545">
                    <label htmlFor="formState">State</label>
                    <input type="text" id="formState" name="state" value={personalDetails.location.state} onChange={handleLocationChange} required />
                  </div>
                  <div className="form-group545">
                    <label htmlFor="formDistrict">District</label>
                    <input type="text" id="formDistrict" name="district" value={personalDetails.location.district} onChange={handleLocationChange} required />
                  </div>
                </div>
                <div className="form-row-dual">
                  <div className="form-group545">
                    <label htmlFor="formDistrict">Hobbies</label>
                    <input type="text" id="formHobbies" name="hobbies" value={personalDetails.hobbies} onChange={handleChange} required />
                  </div>
                  <div className="form-group545">
                    <label htmlFor="formDistrict">Interest</label>
                    <input type="text" id="formInterest" name="interest" value={personalDetails.interest} onChange={handleChange} required />
                  </div>
                </div>
                <div className="form-row-dual">
                  <div className="form-group545">
                    <label htmlFor="formDistrict">Drinking Habits</label>
                    <select type="text" id="formDrinkingHabits" name="drinkingHabits" value={personalDetails.drinkingHabits} onChange={handleChange} required >
                      <option value="">Select Option</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                  </div>
                  <div className="form-group545">
                    <label htmlFor="formDistrict">Smoking Habits</label>
                    <select type="text" id="formSmokingHabits" name="smokingHabits" value={personalDetails.smokingHabits} onChange={handleChange} required >
                      <option value="">Select Option</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                  </div>
                </div>
                <p className="final-check-message">
                  *Please review your details before submitting to ensure everything is accurate.*
                </p>
                <div className="form-row-dual">
                  <button type="button" className="submit-button8989" onClick={handleBack}>Back</button>

                  <button type="submit" className="submit-button8989">Submit</button>
                </div>
              </div>
            )}

          </div>
        </form>

      </div>
    </>
  );
};

export default Create;
